<ng-container *ngrxLet="viewModel$; let model;">
  @if (model.loading) {
    <ngx-skeleton-loader
        class="w-full"
        [theme]="{ marginBottom: 0 }"></ngx-skeleton-loader>
  } @else {
    <div class="my-[auto] h-[18px]">

      @if (!model.location?.foundInMyBusiness) {
        <mat-icon
            class="w-[15px] h-[15px] locationMissingColoring"
            [matTooltip]="getFurtherLocationStatusInfo('missing')"
            svgIcon="fiber_manual_record">
        </mat-icon>
      }
      @if (model.location?.businessStatus === 'CLOSED_PERMANENTLY') {
        <mat-icon
            class="w-[15px] h-[15px] locationBusinessStatusColoring"
            [matTooltip]="getFurtherLocationStatusInfo('permanentlyClosed')"
            svgIcon="fiber_manual_record">
        </mat-icon>
      }
      @if (model.location?.businessStatus === 'CLOSED_TEMPORARILY') {
        <mat-icon
            class="w-[15px] h-[15px] locationBusinessStatusColoring"
            [matTooltip]="getFurtherLocationStatusInfo('temporarilyClosed')"
            svgIcon="fiber_manual_record_outline">
        </mat-icon>
      }
      @if (model?.hasOpenDifferences) {
        <mat-icon
            class="w-[15px] h-[15px] locationDifferencesColoring"
            [matTooltip]="getFurtherLocationStatusInfo('differences')"
            svgIcon="fiber_manual_record_outline">
        </mat-icon>
      }
      @if (model?.hasIgnoredDifferences) {
        <mat-icon
            class="w-[15px] h-[15px] locationDifferencesColoring"
            [matTooltip]="getFurtherLocationStatusInfo('accepted')"
            svgIcon="fiber_manual_record">
        </mat-icon>
      }
      @if (model?.hasBlacklistedFields) {
        <mat-icon
            class="w-[15px] h-[15px] locationBlacklistedFieldsColoring"
            [matTooltip]="getFurtherLocationStatusInfo('blacklisted')"
            svgIcon="fiber_manual_record">
        </mat-icon>
      }
      @if (model.location?.managementStatus === 'NOT_MANAGED') {
        <mat-icon
            class="w-[15px] h-[15px] locationNotManagedColoring"
            [matTooltip]="getFurtherLocationStatusInfo('notManaged')"
            svgIcon="fiber_manual_record">
        </mat-icon>
      }
      @if (model.location?.managementStatus === 'MANUALLY_MANAGED') {
        <mat-icon
            class="w-[15px] h-[15px] locationNotManagedColoring"
            [matTooltip]="getFurtherLocationStatusInfo('manuallyManaged')"
            svgIcon="fiber_manual_record_outline">
        </mat-icon>
      }
      <!-- todo rename BLS-2470 -->
      @if (!model.location?.verified) {
        <mat-icon
            class="w-[15px] h-[15px] locationNotValidatedColoring"
            [matTooltip]="getFurtherLocationStatusInfo('unverified')"
            svgIcon="fiber_manual_record">
        </mat-icon>
      }
      @if (model.location?.lastUpdateErrorMessage) {
        <mat-icon
            class="w-[15px] h-[15px] locationUpdateErrorColoring"
            [matTooltip]="getFurtherLocationStatusInfo('updateError')"
            svgIcon="fiber_manual_record">
        </mat-icon>
      }
      @if (model.location?.lastImportErrorMessage) {
        <mat-icon
            class="w-[15px] h-[15px] locationImportErrorColoring"
            [matTooltip]="getFurtherLocationStatusInfo('importError')"
            svgIcon="fiber_manual_record">
        </mat-icon>
      }
      @if (model.location?.claimAndCleanCompletionTimestamp !== null) {
        <mat-icon
            class="w-[15px] h-[15px] locationHasCompletedCcColoring"
            [matTooltip]="getFurtherLocationStatusInfo('ccCompleted')"
            svgIcon="fiber_manual_record">
        </mat-icon>
      }

    </div>
  }
</ng-container>

